import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const SuccessIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "SuccessIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 12C2 17.5142 6.48633 22 12.0005 22C17.5142 22 22 17.5142 22 12C22 6.48584 17.5142 2 12 2C6.48584 2 2 6.48584 2 12ZM9.8167 15.9998H9.8258C9.9715 15.9998 10.1113 15.9419 10.2147 15.838L17.0908 8.9346C17.3045 8.72034 17.3034 8.3727 17.0886 8.15898C16.8755 7.94525 16.5273 7.9474 16.313 8.16112L9.83866 14.6606L7.69928 12.367C7.49253 12.1447 7.14543 12.1335 6.92421 12.3397C6.70245 12.5464 6.69013 12.8935 6.89689 13.1148L9.42461 15.8251C9.52638 15.9344 9.66779 15.9971 9.8167 15.9998Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default SuccessIcon;
